/* eslint-disable no-useless-escape */
export const firstLetterUpper = (str: string) => {
  const newString = str
    .toLowerCase()
    .replace(/(^\s*\w|[\.\!\?]\s*\w)/g, (c) => {
      return c.toUpperCase();
    });
  return newString;
};
